// extracted by mini-css-extract-plugin
export var cardHeader = "_kj-1";
export var contentCard = "_kj-0";
export var headerActions = "_kj-3";
export var reorderHandle = "_kj-5";
export var titleArea = "_kj-2";
export var titleAreaWithHandle = "_kj-4";